import PropTypes from 'prop-types'
import React from 'react'

const getOverlaySidePosition = (container, target) => {
  let top, left

  const documentWidth = document.body.offsetWidth || document.documentElement.offsetWidth
  const containerViewportPosition = container.getBoundingClientRect()

  top = target.offsetHeight - container.offsetHeight
  left = target.offsetWidth

  // Adjust top if exceeds viewport at the top
  if (Math.abs(top) > containerViewportPosition.top) {
    top = -containerViewportPosition.top
  }

  // Display container on the left side of the target if it exceeds viewport on the right side
  if (target.offsetWidth + containerViewportPosition.right > documentWidth) {
    left = -container.offsetWidth
  }

  return {
    top,
    left
  }
}

const POSITION_STRATEGIES = {
  'side': getOverlaySidePosition
}

class Overlay extends React.Component {
  static propTypes = {
    content: PropTypes.object,
    position: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ])
  }

  static defaultProps = {
    position: 'side'
  }

  constructor (props) {
    super(props)

    this.state = {
      showContent: false
    }

    this.timeoutId = null
  }

  getOverlayPosition (container, target) {
    if (typeof this.props.position === 'function') {
      return this.props.position(container, target)
    }
    return POSITION_STRATEGIES[this.props.position](container, target)
  }

  componentDidUpdate () {
    if (this.state.showContent && this.$target && this.$content) {
      const position = this.getOverlayPosition(this.$content, this.$target)
      this.$content.style.left = `${position.left}px`
      this.$content.style.top = `${position.top}px`
    }
  }

  onMouseEnter () {
    this.timeoutId = setTimeout(() => {
      this.setState({showContent: true})
    }, 500)
  }

  onMouseLeave () {
    clearTimeout(this.timeoutId)
    this.setState({showContent: false})
  }

  renderContent () {
    return (
      <div ref={$content => { this.$content = $content }} style={{ display: 'inline-block', position: 'absolute' }}>
        {this.props.content}
      </div>
    )
  }

  render () {
    return (
      <div style={{position: 'relative'}}>
        {this.state.showContent && this.renderContent()}
        <div ref={$target => { this.$target = $target }}
          style={{display: 'inline-block'}}
          onMouseEnter={this.onMouseEnter.bind(this)}
          onMouseLeave={this.onMouseLeave.bind(this)}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Overlay



// WEBPACK FOOTER //
// ./client/components/overlay.js